export const VonEmployeeTypes = {
    User: 0,
    Auditor: 1,
    Conversion: 2,
    BankruptcyTrustee: 3
}

export const VonEmployeeTypesText = {
    [VonEmployeeTypes.User]: "vonEmployeeTypes.user",
    [VonEmployeeTypes.Auditor]: "vonEmployeeTypes.auditor",
    [VonEmployeeTypes.Conversion]: "vonEmployeeTypes.conversion",
    [VonEmployeeTypes.BankruptcyTrustee]: "vonEmployeeTypes.bankruptcytrustee"
};